import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import logo from '../assets/icon.png'; // relative path to image

/* FontAwesome */
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTimesCircle,
  faInfo,
  faRoute,
  faBars,
  faListAlt,
  faPowerOff,
  faUserFriends,
  faTachometerAlt,
  faTrashAlt,
  faPlusCircle,
} from '@fortawesome/free-solid-svg-icons';

// Add FontAwesome icons
library.add([
  faTimesCircle,
  faInfo,
  faRoute,
  faBars,
  faListAlt,
  faPowerOff,
  faUserFriends,
  faTachometerAlt,
  faTrashAlt,
  faPlusCircle,
]);

// The Header creates links that can be used to navigate
// between routes.
class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      about: false,
    };
  }

  render() {
    const { game } = this.props;
    const title = game.data ? game.data.name : '';

    let menuItems = [
      { url: '/login', label: 'Sign-In' },
      { url: '/register', label: 'Sign-Up' },
    ];

    const menuLinks = menuItems.map((l, li) => {
      return (
        <Link
          to={l.url}
          key={`menu-item-${li}`}
          className={
            li === menuItems.length - 1
              ? 'btn border-start px-4 px-md-4 border-end'
              : 'btn border-start px-4 px-md-4'
          }>
          {l.label}
        </Link>
      );
    });

    return (
      <header
        className='app-header'
        style={{ margin: '0 calc(var(--bs-gutter-x) * -.5)' }}>
        <nav id='main-menu' className='navbar'>
          <Link className='navbar-brand title me-0 me-md-2' to='/library'>
            <img
              src={logo}
              className='logo'
              style={{ height: '30px', marginRight: '10px', marginTop: '-9px' }}
              alt='logo'
            />
            HUB{' '}
            {game.data && (
              <small className='d-inline-block fw-light ms-4'>{title}</small>
            )}
          </Link>

          <div className='flex-fill menu-links'>{menuLinks}</div>
          {/* {menuLinks} */}

          {/* <div className='ms-auto me-3'></div> */}
        </nav>
      </header>
    );
  }
}

function mapStateToProps(state) {
  const { player, game } = state;
  return {
    game,
    player,
  };
}

export default connect(mapStateToProps)(Header);
